import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

// const USER_API_BASE_URL = "http://localhost:8080/campagne";

class CampagneService {
  //filtre
  getCampagnesByFiltre(
    idUser,
    nom,
    canalDiffusion,
    statut,
    startDate,
    endDate
  ) {
    return api.get(
      UtilsUrl.marketingURL() +
        "/campagne/filtre/" +
        idUser +
        "?nom=" +
        nom +
        "&canalDiffusion=" +
        canalDiffusion +
        "&statut=" +
        statut +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate
    );
  }
  //Afficher List CanalDiffusion
  AfficherListCanalDiffusion(idUser) {
    return api.get(
      UtilsUrl.marketingURL() + "/campagne/getCanalDiffusions/" + idUser
    );
  }

  //Afficher List Statut
  AfficherListStatus(idUser) {
    return api.get(UtilsUrl.marketingURL() + "/campagne/getStatus/" + idUser);
  }

  //Afficher List Objectifs
  AfficherListObjectifs(idUser) {
    return api.get(
      UtilsUrl.marketingURL() + "/campagne/getObjectifs/" + idUser
    );
  }
}

export default new CampagneService();
